import { useNavigate } from "react-router-dom";
import { useEditMode } from "@/context/EditModeContext";
import { Check, Loader2, LogOut, Pencil } from "lucide-react";

const LANGS = [
  { code: "en", label: "EN" },
  { code: "cs", label: "CS" },
  { code: "he", label: "עב" },
  { code: "ru", label: "RU" },
];

export function EditToolbar() {
  const em = useEditMode();
  const navigate = useNavigate();
  if (!em.editing) return null;

  return (
    <div data-testid="edit-toolbar" className="fixed bottom-4 left-1/2 z-[9000] -translate-x-1/2">
      <div className="flex items-center gap-3 rounded-full bg-[#0F172A] px-4 py-2.5 text-white shadow-2xl ring-1 ring-white/10">
        <span className="hidden sm:flex items-center gap-1.5 text-sm font-semibold text-[#BE923C]"><Pencil size={14} /> Editing</span>
        <div className="h-5 w-px bg-white/15" />
        <span className="text-xs text-white/60">Language</span>
        <div className="flex items-center gap-1">
          {LANGS.map((l) => (
            <button key={l.code} data-testid={`edit-lang-${l.code}`} onClick={() => em.setEditLang(l.code)}
              className={`rounded-full px-2.5 py-1 text-xs font-bold transition-colors ${em.editLang === l.code ? "bg-[#BE923C] text-white" : "text-white/70 hover:bg-white/10"}`}>
              {l.label}
            </button>
          ))}
        </div>
        <div className="h-5 w-px bg-white/15" />
        <span className="flex items-center gap-1.5 text-xs text-white/70 min-w-[64px]">
          {em.saving ? (<><Loader2 size={13} className="animate-spin" /> Saving…</>) : (<><Check size={13} className="text-green-400" /> Saved</>)}
        </span>
        <button data-testid="edit-exit" onClick={() => navigate("/admin")}
          className="flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1.5 text-xs font-semibold hover:bg-white/20">
          <LogOut size={13} /> Exit
        </button>
      </div>
    </div>
  );
}
